import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 lg:py-16" data-id="element-81">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-82">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-83">
          <div data-id="element-84">
            <div className="flex items-center gap-2 mb-4" data-id="element-85">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center" data-id="element-86">
                <span className="text-white font-bold" data-id="element-87">M</span>
              </div>
              <span className="text-lg font-semibold text-white" data-id="element-88">
                Master Merchant
              </span>
            </div>
            <p className="text-sm" data-id="element-89">
              Powered by Freedom Fate, Inc. — the only nonprofit helping other
              nonprofits process payments instantly.
            </p>
          </div>

          <div data-id="element-90">
            <h3 className="text-white font-semibold mb-4" data-id="element-91">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-92">
              <li data-id="element-93">
                <a href="#" className="hover:text-white transition-colors" data-id="element-94">
                  Features
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:text-white transition-colors" data-id="element-96">
                  Pricing
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="hover:text-white transition-colors" data-id="element-98">
                  Security
                </a>
              </li>
              <li data-id="element-99">
                <a href="#" className="hover:text-white transition-colors" data-id="element-100">
                  Integrations
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-101">
            <h3 className="text-white font-semibold mb-4" data-id="element-102">Company</h3>
            <ul className="space-y-2 text-sm" data-id="element-103">
              <li data-id="element-104">
                <a href="#" className="hover:text-white transition-colors" data-id="element-105">
                  About
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-white transition-colors" data-id="element-107">
                  Blog
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-white transition-colors" data-id="element-109">
                  Careers
                </a>
              </li>
              <li data-id="element-110">
                <a href="#" className="hover:text-white transition-colors" data-id="element-111">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-112">
            <h3 className="text-white font-semibold mb-4" data-id="element-113">Support</h3>
            <ul className="space-y-2 text-sm" data-id="element-114">
              <li data-id="element-115">
                <a href="#" className="hover:text-white transition-colors" data-id="element-116">
                  Help Center
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-white transition-colors" data-id="element-118">
                  Documentation
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-white transition-colors" data-id="element-120">
                  API Reference
                </a>
              </li>
              <li data-id="element-121">
                <a href="#" className="hover:text-white transition-colors" data-id="element-122">
                  Status
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-123">
          <p data-id="element-124">© 2024 Master Merchant. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-125">
            <a href="#" className="hover:text-white transition-colors" data-id="element-126">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-127">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-128">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}